import { t } from 'i18next';

export const batteryLevelPresenter = (batteryLevel: number | null) => {
  // when device on charge it send "pwr" as batt level, we save it as 11
  if (batteryLevel === 11) {
    return t('labels.charging');
  }
  return batteryLevel;
};
